import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import {
  FieldDefinitionDto,
  TableDefinitionDto,
} from '@/components/table/types/TableDefinitionDto.ts';
import { SingleFilterForm } from '@/components/table/schemas/filterCriteriaSchema.ts';
import { UrlFilter } from '@/components/table/routes/listSearchParams.ts';

type FilterBuilder = (
  field: FieldDefinitionDto,
  filter: UrlFilter,
) => SingleFilterForm;

const textValue: FilterBuilder = (field, filter) =>
  ({
    fieldId: field.fieldId,
    type: field.type,
    operator: filter.o,
    value: filter.v,
  }) as SingleFilterForm;

/**
 * Typy, dla których adres umie zbudować filtr; kolejne dochodzą z pierwszym linkiem, który ich potrzebuje.
 * ENUM idzie tablicą — tak zapisuje go `MultiSelectInput` panelu i tak przyjmuje go backend
 * (`EnumFieldFilterDto.value: List<String>`), choć `enumFilterSchema` deklaruje napis.
 */
const BUILDERS: Partial<Record<FieldType, FilterBuilder>> = {
  [FieldType.ENUM]: (field, filter) =>
    ({
      fieldId: field.fieldId,
      type: field.type,
      operator: filter.o,
      value: [filter.v],
    }) as unknown as SingleFilterForm,
  [FieldType.TEXT]: textValue,
  [FieldType.ID]: textValue,
};

/** Filtry z adresu na formularz tabeli. Pole musi istnieć, być filtrowalne i znać operator — reszta wypada po cichu. */
export const urlFiltersToFilterForm = (
  definition: TableDefinitionDto,
  urlFilters: UrlFilter[] | undefined,
): SingleFilterForm[] =>
  (urlFilters ?? []).flatMap((filter) => {
    const field = definition.fields.find(
      (candidate) => candidate.fieldId === filter.f,
    );
    const build = field ? BUILDERS[field.type] : undefined;
    if (!field || !build || !field.filterable) return [];
    if (!field.operators.includes(filter.o) || filter.v.trim() === '')
      return [];
    return [build(field, filter)];
  });
